var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEbooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ebooks",
    d: "M14.9894 4.01088L14.177 1.32262C14.3758 1.19505 14.51 0.972168 14.51 0.717707C14.51 0.320934 14.1891 0 13.7916 0H2.71309C1.96582 0 1.28301 0.30482 0.794923 0.794922C0.304821 1.283 -0.000686342 1.96582 1.1579e-06 2.7124V20.2275C1.1579e-06 21.2064 0.793591 22 1.77246 22H14.7705C15.595 22 16.2637 21.332 16.2637 20.5075V5.48187C16.2637 4.73193 15.7091 4.1183 14.9894 4.01088ZM2.71309 3.98939C2.35791 3.98939 2.04304 3.84704 1.81006 3.61543C1.57777 3.38112 1.43542 3.06689 1.43542 2.7124C1.43542 2.35791 1.57777 2.04304 1.81006 1.80937C2.04304 1.57773 2.35791 1.43541 2.71309 1.43541H13.1108L13.8829 3.98939H2.71309Z",
    fill: "#8D90A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbooks);
export default __webpack_public_path__ + "static/media/ebooks.5416f001fa8773485f4f93280df7ad44.svg";
export { ForwardRef as ReactComponent };